<template>
    <page>

        <div :class="isMobile ? '' : 'padding-gt-sm'" class="column full-width bg-white q-px-md q-py-lg justify-between" :style="!loginFromOpen ? 'min-height: calc(100vh - 91px);' : ''" v-if="mockData && user">

            <q-card v-if="mockData && user && user.market_id === 1 &&
            (user.role.name === 'Lending Point' || user.role.name === 'Sales Expert' || user.role.name === 'MUPI' || user.role.name === 'Remote Coach') && hasPendingStock"
                    class="row col-6 items-center text-negative bg-hard-white text-center" :class="isMobile ? 'q-mb-md' : 'q-mb-xl'" flat>
                <q-card-main style="width: 100%; font-size: 16px;">
                    Se ha generado una reposición de dispositivos de préstamo para tu punto de venta y la recibirás en las próximas 24-48 horas. Ten preparado todos los dispositivos “usados” (pendientes de sanitizar) para entregar al mensajero
                </q-card-main>
            </q-card>

            <div class="row justify-center">
                <div class="row justify-center" :class="$q.screen.gt.md ? 'gutter-xl' : 'gutter-md'" :id="user.role.name === 'Lending Point' || user.role.name === 'Sales Expert' || user.role.name === 'MUPI' || user.role.name === 'Remote Coach' ? 'row-chart-widget' : ''">
                    <chart-widget class="col-xl-6 col-lg-6 col-sm-6 col-xs-12"
                                v-for="(item, i) in widgetsIn(menuItems)"
                                :key="i"
                                :chart-type="item.widgetType || 'card'"
                                :has-chip="item.hasChip && (user.role.name === 'Lending Point' || user.role.name === 'Sales Expert' || user.role.name === 'MUPI' || user.role.name === 'Remote Coach')"
                                :chip-text="reservationCount()"
                                :footer-text="footerTextFor(item)"
                                :footer-icon="footerIconFor(item)"
                                :chart-icon="item.icon"
                                :title="$T(item.label)"
                                :subtitle="$T(item.subtitle)"
                                v-model="mockData[`${item.route}.value`]"
                                :to="{name: item.route}"
                                  :class="item.hasOwnProperty('highlight') && item.highlight ? 'highlight-widget-label' : ''"/>

                </div>
                <div class="q-mt-lg col-12 cursor-pointer row chart-secondary justify-around lt-md">
                    <div class="col-2 row items-center">
                        <img src="./../../img/call-center.svg" width="50px" height="50px" alt="call-center icon">
                    </div>
                    <div class="col-9 text-center">
                        <p class="font-label text-weight-bold q-my-none">900 350 350</p>
                        <p class="font-label text-weight-bold q-my-none">¿Tienes algún problema?</p>
                        <p class="font-label q-my-none">Llama a nuestro Call Center</p>
                    </div>
                </div>
            </div>

            <div class="row justify-center gt-sm">
                <div class="q-mt-lg cursor-pointer row chart-secondary-lg justify-between no-wrap">
                    <div class="row items-center">
                        <img src="./../../img/call-center.svg" width="50px" height="50px" alt="call-center icon">
                    </div>
                    <div class="col-11 text-center q-pl-md">
                        <p class="font-label text-weight-bold q-my-none">900 350 350</p>
                        <p class="font-label text-weight-bold q-my-none">¿Tienes algún problema?</p>
                        <p class="font-label q-my-none">Llama a nuestro Call Center</p>
                    </div>
                </div>
            </div>

        </div>
        <div class="row justify-center items-center row-spinner-height" v-else>
            <spinner-iqos size="60px"/>
        </div>
    </page>
</template>

<script>
import moment from 'moment'
import {mapGetters} from 'vuex'
import menuItems from '../menuItems'
import axios from 'axios'
import store from "../store";

export default {
    mixins: [menuItems],

    middleware: ['check-open-auth', 'auth'],

    metaInfo() {
        return {title: this.user ? this.user.role.name : this.$T('home')}
    },

    data() {
        return {
            slug: 'v1/home',
            mockData: null,
            refreshTimer: null,
            nowTimer: null,
            isMobile: true,
            loginFromOpen: false
        }
    },

    created() {
        // Wrong market for user
        if (this.user.market.abbreviation !== window.config.market) {
            this.$router.push({name: 'error-4004'})
            return
        }

        if (this.$route.query.token) {
            // Save the token.
            this.$store.dispatch('auth/saveToken', {
                token: this.$route.query.token,
            })

        }

        if (this.user.login_from_open) {
            this.$root.$emit('loginFromOpen')
            this.loginFromOpen = true
        }

        if (this.user.role.name === 'Logista') {
            this.$router.push({name: 'backoffice.lending-kit.index'})
            return
        }

        this.nowTimer = setInterval(() => {
            if (this.mockData)
                this.mockData.serverTime = moment(this.mockData.serverTime)
                    .add(1, 'second').format('YYYY-MM-DD HH:mm:ss')
        }, 1000)
        this.refreshTimer = setInterval(this.getMockData, 60 * 1000)

        //declara function to use with native ios camera call
        const updateDevice = (value) => {

            let updateDeviceEvent = new CustomEvent("updateDeviceEvent", {
                detail: {
                    value: value
                }
            });

            window.dispatchEvent(updateDeviceEvent)
        }

        window.updateDevice = updateDevice;
    },

    destroyed() {
        clearInterval(this.nowTimer)
        clearInterval(this.refreshTimer)
    },

    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),

        hasPendingStock() {
            return this.mockData.hasOwnProperty('has_pending_stock') && this.mockData.has_pending_stock
        }
    },

    methods: {
        /**
         * Loads the "mock data" from the store
         */
        async getMockData() {
            const {data} = await axios.get(`${config.appUrl}/api/${this.slug}/kpis`)
            this.mockData = data.data
            this.validateMenus()
        },

        validateMenus() {
            let user = store.getters['auth/user']
            let menus = this.menuItems;
            let newMenus = [];
            for (let i = 0; i < menus.length; i++) {
                if (menus[i].route === 'lending-point.order' || menus[i].route === 'sales-expert.order') {
                    if (user.lending_point && user.lending_point.enable_lending_creation) {
                        newMenus.push(menus[i])
                    }
                } else if (menus[i].route === 'lending-point.lending-kits.add') {
                    if (this.mockData && this.mockData.canViewAddLendingKitsMenu) {
                        newMenus.push(menus[i])
                    }
                } else if (menus[i].label === 'external return') {
                    if (this.mockData.externalReturn === '1') {
                        newMenus.push(menus[i])
                    }
                } else if (menus[i].label === 'kit reservation at POS') {
                    user.market.configurations.filter(config => {
                        if (config.description === 'enable_kit_reservation' && parseInt(config.pivot.value) === 1) newMenus.push(menus[i])
                    })
                } else if (menus[i].label === 'partners') {
                    user.market.configurations.filter(config => {
                        if (config.description === 'enable_partner_to_remote_coach' && parseInt(config.pivot.value) === 1) newMenus.push(menus[i])
                    })
                } else {
                    newMenus.push(menus[i])
                }
            }
            this.menuItems = newMenus;
        },

        widgetsIn(list) {
            return list.reduce((flat, item) => flat.concat(item.children ? item.children : item), [])
                .filter(item => item.widget && this.canISeeThis(item.role))
                .filter(item => item.widget && this.marketCanSeeThis(item.market))
                .filter(item => this.externalReturnForMarket(item.label))
        },

        canISeeThis(role) {
            return role instanceof Array ?
                role.includes(this.user.role.name) :
                role == this.user.role.name
        },

        marketCanSeeThis(role) {
            return role instanceof Array ?
                role.includes(this.user.market.abbreviation) || role.includes('*') :
                role == this.user.market.abbreviation

        },

        externalReturnForMarket(label) {
            if (label === 'external return') {
                return this.mockData.externalReturn === '1' ? true : false
            } else {
                return true
            }
        },

        footerTextFor(item) {
            if (item.subTitle)
                return this.$T(item.subTitle)
            if (this.mockData[`${item.route}.footerText`] && this.mockData[`${item.route}.updatedAt`])
                return '<strong>' + this.mockData[`${item.route}.footerText`] + '</strong>' +
                    ` ${this.$T('updated')} ${moment(this.mockData[`${item.route}.updatedAt`]).from(this.mockData.serverTime)}`
            if (this.mockData[`${item.route}.footerText`])
                return this.mockData[`${item.route}.footerText`]
            if (this.mockData[`${item.route}.updatedAt`])
                return `${this.$T('updated')} ${moment(this.mockData[`${item.route}.updatedAt`]).from(this.mockData.serverTime)}`
            return ''
        },

        footerIconFor(item) {
            if (item.footerIcon)
                return item.footerIcon
            if (this.mockData[`${item.route}.updatedAt`])
                return 'update'
            return 'info'
        },

        reservationCount() {
            return this.findValInObject(this.mockData, 'lending-point.orders.pending.value');
        },

        findValInObject(object, key) {
            let value;
            Object.keys(object).some((k) => {
                if (k === key) {
                    value = object[k];
                    return true;
                }
                if (object[k] && typeof object[k] === 'object') {
                    value = this.findValInObject(object[k], key);
                    return value !== undefined;
                }
            });
            return value;
        }
    },

    mounted() {
        this.getMockData()
        this.isMobile = this.$q.platform.is.mobile
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/home.vue